import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function List() {
    const session = useSelector((state) => { return state.core.session });

    const profileFilter = chooseProfileFilter();

    const navigate = useNavigate();

    const pathFrontEnd = '/bankinghistories/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllBankAccounts: config.endpoints.backend + 'bankaccounts/getall',
        endpointDelete: `${config.endpoints.backend}bankinghistories/delete`,
        endpoint: config.endpoints.backend + 'bankinghistories/getall'
    }

    let list = {
        labelTitle: 'Histórico de Transações',
        labelTitleButtonAdd: 'Importar Extrato',
        fieldsShowOnDelete: ['trnamt'],
        showPrintButtons: true,
        canEdit: false,
        canView: false,
        canAdd: false,
        filter: {
            ...profileFilter,
            ...session.banking_history_params
        },
        columns: [
            {
                name: 'entity_name',
                label: 'Entidade',
            },
            {
                name: 'project_name',
                label: 'Projeto',
            },
            {
                name: 'bank',
                label: 'Banco',
                width: '15%'
            },
            {
                name: 'trnamt',
                label: 'Valor',
                width: '10%'
            },
            {
                name: 'dtposted',
                label: 'Data',
                width: '10%'
            },
            {
                name: 'memo',
                label: 'Descrição'
            }
        ],
        buttonsListContainer: [
            {
                name: 'competencies_baking_histories',
                class: 'btn btn-secondary',
                label: 'Voltar',
                tooltipLabel: 'Voltar',
                callback: async () => {
                    navigate(`/bankinghistories/competencies`)
                }
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                canAdd={list.canAdd}
                buttons={list.buttonsListContainer}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
